import {ChartDonut, Flask, Stack} from '../../components/PhosphorIcons'
import {FeatureCard} from '../../components/FeatureCard'
import {PageHeader} from '../../layout/PageHeader'

const DashboardPage = () => (
  <>
    <div className='feature-grid'>
      <FeatureCard
        to='/portfolio/overview'
        title='Портфель'
        description='Структура активов и состояние счетов'
        icon={<ChartDonut aria-hidden='true' size={22} weight='duotone' />}
        tone='primary'
      />
      <FeatureCard
        to='/strategies/overview'
        title='Стратегии'
        description='Сценарии регулярного денежного потока'
        icon={<Flask aria-hidden='true' size={22} weight='duotone' />}
      />
      <FeatureCard
        to='/instruments'
        title='Инструменты'
        description='Акции, облигации, фонды и валюты'
        icon={<Stack aria-hidden='true' size={22} weight='duotone' />}
        tone='emerald'
      />
    </div>

    <div className='dashboard-grid dashboard-grid--accounts'>
      <div>
        <favourites-widget />
      </div>
      <div>
        <broker-accounts-widget />
      </div>
    </div>

    <div className='dashboard-grid dashboard-grid--portfolio'>
      <div>
        <portfolio-widget />
      </div>
      <div>
        <payout-info-widget />
      </div>
    </div>

    <signals-widget />
  </>
)

const DashboardWrapper = () => (
  <>
    <PageHeader
      eyebrow='Персональный офис'
      title='Финансовая лаборатория'
      description='Счета, портфельные сигналы и инвестиционные сценарии в одном рабочем пространстве.'
    />
    <DashboardPage />
  </>
)

export {DashboardWrapper}
